const SchoolsUtil = {
  /*
    Takes in a school type as per MIUR DB, and returns a schoolclass group (KINDR, ELEM, MIDDLE, HIGH)

    These are all groups:
    KINDR
    ELEM
    MIDDLE
    HIGH

    These are all types on DB:
    CENTRO TERRITORIALE
    CONVITTO ANNESSO
    CONVITTO NAZIONALE
    EDUCANDATO
    IST PROF ALBERGHIERO
    IST PROF CINEMATOGRAFIA E TELEVISIONE
    IST PROF INDUSTRIA E ARTIGIANATO
    IST PROF INDUSTRIA E ARTIGIANATO PER CIECHI
    IST PROF INDUSTRIA E ARTIGIANATO PER SORDOMUTI
    IST PROF INDUSTRIA E ATTIVITA' MARINARE
    IST PROF PER I SERVIZI ALBERGHIERI E RISTORAZIONE
    IST PROF PER I SERVIZI COMM TUR E DELLA PUBB
    IST PROF PER I SERVIZI COMMERCIALI
    IST PROF PER I SERVIZI COMMERCIALI E TURISTICI
    IST PROF PER I SERVIZI PUBBLICITARI
    IST PROF PER I SERVIZI SOCIALI
    IST PROF PER I SERVIZI TURISTICI
    IST PROF PER L'AGRICOLTURA
    IST PROF PER L'AGRICOLTURA E L'AMBIENTE
    IST PROFÂ  ALBERGHIERO
    IST TEC COMMERCIALE E PER GEOMETRI
    IST TECNICO COMMERCIALE
    ISTITUTO COMPRENSIVO
    ISTITUTO D'ARTE
    ISTITUTO MAGISTRALE
    ISTITUTO SUPERIORE
    ISTITUTO TECNICO AERONAUTICO
    ISTITUTO TECNICO AGRARIO
    ISTITUTO TECNICO COMMERCIALE
    ISTITUTO TECNICO INDUSTRIALE
    ISTITUTO TECNICO NAUTICO
    ISTITUTO TECNICO PER ATTIVITA' SOCIALI (GIA' ITF)
    ISTITUTO TECNICO PER GEOMETRI
    ISTITUTO TECNICO PER IL TURISMO
    LICEO ARTISTICO
    LICEO CLASSICO
    LICEO LINGUISTICO
    LICEO SCIENTIFICO
    SCUOLA INFANZIA
    SCUOLA INFANZIA NON STATALE
    SCUOLA MAGISTRALE
    SCUOLA PRIMARIA
    SCUOLA PRIMARIA NON STATALE
    SCUOLA PRIMO GRADO
    SCUOLA SEC. PRIMO GRADO NON STATALE
    SCUOLA SEC. SECONDO GRADO NON STATALE

   */
  getSchoolclassGroupsFromType: (schoolType) => {
    if (schoolType == 'ISTITUTO COMPRENSIVO') {// ISTITUTO COMPRENSIVO could be anything, but high school
      return [
        'KINDR',
        'ELEM',
        'MIDDLE'
      ];
    } else {
      // get an array of strings that if the type starts with that, they match the group
      const groupTypes = {
        // infanzia
        'KINDR': [
          'SCUOLA INFANZIA'
        ],

        // primaria (elem)
        'ELEM': [
          'SCUOLA PRIMARIA'
        ],

        // secondaria I grado (media)
        'MIDDLE' : [
          'SCUOLA PRIMO GRADO',
          'SCUOLA SEC. PRIMO'
        ],

        // secondaria II grado (liceo)
        'HIGH': [
          'IST',
          'LICEO',
          'SCUOLA SEC. SECONDO',
          'SCUOLA MAGISTRALE',

          // weird ones
          'CENTRO TERRITORIALE',
          'CONVITTO ANNESSO',
          'CONVITTO NAZIONALE',
          'EDUCANDATO'
        ]
      };

      const groupsNames = Object.keys(groupTypes);
      for (let i=0; i<groupsNames.length; i++) {
        const groupName = groupsNames[i];
        const typeStrings = groupTypes[groupName];

        for (let j=0; j<typeStrings.length; j++) {
          const typeString = typeStrings[j];

          const isMatch = schoolType.indexOf(typeString) === 0;
          if (isMatch) {
            return [groupName];
          }
        }
      }
    }

    return false;
  }
}

export default SchoolsUtil;


// WEBPACK FOOTER //
// ./src/utils/SchoolsUtil.js